import { FC } from 'react';
import Icon from 'components/Icon';
import messages from './Messages';
import { MultiChoiceViewer } from '../../MultiChoice';
import {
  IMultipleChoiceQuestionView,
  IQuestionTags,
  ISurveyView,
  QuestionState,
} from 'store/survey/surveyTypes';
import { black } from '../../../../../../../utils/style/colors';
import styled from 'styled-components';

const TagBadge = styled.span`
  display: inline-block;
  background: ${black};
  border-radius: 0.5rem;
  color: var(--exact-white);
  padding: 0.25rem 0.5rem;
  font-size: 0.8rem;
`;

interface IComponentProps {
  useTags: boolean;
  viewMode: IMultipleChoiceQuestionView['viewMode'];
  choiceList: IMultipleChoiceQuestionView['choiceList'];
  survey?: ISurveyView;
  tags: IQuestionTags;
  question: { data: IMultipleChoiceQuestionView; state: QuestionState };
}

const TagChoiceViewer: FC<IComponentProps> = ({
  useTags,
  choiceList,
  survey,
  tags,
  question,
}) => {
  // TODO: show viewMode of multipleChoiceQuestion
  const parentTagId = question.data.parentTagChoices;
  const allSubTagsId = question.data.tagChoices;

  return useTags ? (
    <>
      <span>
        <Icon type="check-circle" className="right" />
        {messages.choicesMessage}
      </span>
      <span className="flex flex-col my-3">
        {parentTagId && (
          <div className="flex flex-col gap-3">
            <span>{messages.allSubTagsOf}</span>
            <div className="flex flex-wrap gap-2">
              {parentTagId.map((tagId: number) => {
                return <TagBadge key={tagId}>{tags[tagId]?.text}</TagBadge>;
              })}
            </div>
          </div>
        )}
        {allSubTagsId && (
          <div className="flex flex-col">
            <span className="col s12">{messages.allTagsOf}</span>
            <div className="flex flex-wrap gap-2">
              {allSubTagsId.map((tagId: number) => {
                return <TagBadge key={tagId}>{tags[tagId]?.text}</TagBadge>;
              })}
            </div>
          </div>
        )}
      </span>
    </>
  ) : (
    <MultiChoiceViewer
      choices={choiceList}
      hasScore={true}
      booleanValue={
        survey?.surveyType === 'Exam' || survey?.surveyType === 'Bank'
      }
    >
      <span style={{ color: black }}>
        <Icon type="check-circle" className="right" />
        {messages.choicesMessage}
      </span>
    </MultiChoiceViewer>
  );
};
export default TagChoiceViewer;
